import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

// Compatibility shim for react-router v5's withRouter HOC.
// Exposes history.push/replace/goBack plus location and match.params
// on top of react-router v7 hooks so legacy class/function components
// keep working unchanged.
export const withRouter = (Component) => {
  const ComponentWithRouterProps = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const history = {
      push: (to, state) => {
        if (to && typeof to === "object") {
          navigate(
            { pathname: to.pathname, search: to.search, hash: to.hash },
            { state: to.state !== undefined ? to.state : state }
          );
        } else {
          navigate(to, { state });
        }
      },
      replace: (to, state) => {
        if (to && typeof to === "object") {
          navigate(
            { pathname: to.pathname, search: to.search, hash: to.hash },
            { replace: true, state: to.state !== undefined ? to.state : state }
          );
        } else {
          navigate(to, { replace: true, state });
        }
      },
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      go: (n) => navigate(n),
      location,
    };

    const match = {
      params,
      path: location.pathname,
      url: location.pathname,
    };

    return (
      <Component
        {...props}
        history={history}
        location={location}
        match={match}
        navigate={navigate}
      />
    );
  };

  ComponentWithRouterProps.displayName = `withRouter(${
    Component.displayName || Component.name || "Component"
  })`;

  return ComponentWithRouterProps;
};

export default withRouter;
